import { ClientApolloProvider } from '@gdp/react-app-plugin-apollo/lib/ClientApolloProvider';
import { IntrospectionFragmentMatcher } from '@gdp/react-app-plugin-apollo/node_modules/apollo-cache-inmemory';
import { ClientHelmetProvider } from '@gdp/react-app-plugin-helmet/lib/ClientHelmetProvider';
import { ClientReduxProvider } from '@gdp/react-app-plugin-redux/lib/ClientReduxProvider';
import { ClientRouterProvider } from '@gdp/react-app-plugin-router/lib/ClientRouterProvider';
import { register as registerServiceWorker } from '@gdp/react-app/lib/helpers/serviceWorker';
import { client } from '@gdp/react-app/lib/platforms/client';
import { ClientStyleProvider } from '@gdp/react-app/lib/platforms/client/providers/ClientStyleProvider';

import '@gdp/react-app/lib/helpers/polyfills';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

import Thunk from 'redux-thunk';

import { App, Config, ConfigContextProvider } from 'src/app';
import { appReducer } from 'src/app/reducers/app';
import { defaultOptions, initialData, resolvers } from '../config/graphql';

import apolloCodegenSchema from '../../schema.json';

const apolloCodegenData = apolloCodegenSchema as any;
const introspectionQueryResultData = {
  ...apolloCodegenData,
  __schema: {
    ...apolloCodegenData.__schema,
    types: apolloCodegenData.__schema.types.filter((type: any) => type.possibleTypes !== null)
  }
};
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData
});

client<Config>().then(({ compile, config }) => {
  compile(
    <ConfigContextProvider value={config}>
      <App locale={config.locale} />
    </ConfigContextProvider>,
    {
      apollo: new ClientApolloProvider(
        window.__APOLLO_STATE__ || {},
        {
          credentials: 'include',
          uri: config.app.graphqlUrl
        },
        {
          options: {
            lazy: true,
            reconnect: true
          },
          uri: config.app.wsUrl
        },
        defaultOptions,
        { fragmentMatcher },
        undefined,
        resolvers,
        initialData
      ),
      helmet: new ClientHelmetProvider(),
      redux: new ClientReduxProvider(appReducer, [Thunk], config.platform.environment === 'development'),
      router: new ClientRouterProvider(),
      style: new ClientStyleProvider()
    },
    (element, dependencies) => {
      Loadable.preloadReady().then(() => {
        ReactDOM.hydrate(element, document.getElementById('project-root'));
      });
      delete window.__APOLLO_STATE__;
    }
  );

  registerServiceWorker(config);
});
